<nav class="tab-nav">
    <a class="tab-title" *ngFor="let tab of tabs"
       [ngClass]="{ 'is-active': tab.active }"
       (click)="activateTab(tab)">{{ tab.name }}</a>
</nav>
<section class="tab-contents">
    <article class="tab-section" [attr.name]="tab.name" *ngFor="let tab of tabs; index as i;"
             [ngClass]="{ 'is-active': tab.active }">
        <slot name="tab_{{ i + 1 }}"></slot>
    </article>
</section>
